import { useBreakpoints } from '../../../hooks/useBreakpoints';
import { EventItem } from '../../../types/event.type';
import Button from '../../button/v2/button';
import OverlayButton from '../../button/v2/overlay.button';
import Container from '../../containers/container';
import { EventsOptionsDropdown } from '../../dropdown/events.dropdown';
import Icon from '../../icons/icon';
import Avatar from '../../images/avatar';
import { HStack, VStack } from '../../layouts/stack.layout';
import Heading from '../../typography/v2/heading';
import Text from '../../typography/v2/text';
import LinkToItem from '../../utility/link-to-item';
import Card from '../card';

type FeedCardProps = {
  data: EventItem;
  onClick: Function;
};

const styles = {
  container:
    'rounded-xl justify-items-stretch relative w-full mobile:min-h-[275px] tablet-sm:min-h-[400px] flex flex-col justify-between',
  header: 'p-2',
  footer: 'px-2 py-3 bg-black/20 backdrop-blur-xl rounded-b-xl',
};

export default function EventsCard(props: FeedCardProps) {
  const { data, onClick } = props;

  const { isMobile, isTabletLg } = useBreakpoints();

  return (
    <Card
      onClick={isMobile && !isTabletLg ? () => onClick(data) : () => {}}
      backgroundImage={data.imageSrc}
      className={styles.container}
    >
      <Card.Header className={styles.header}>
        <HStack justify="end">
          <EventsOptionsDropdown id={data.id} />
          <OverlayButton id={data.id} name="EVENT" />
        </HStack>
      </Card.Header>
      <Card.Footer className={styles.footer}>
        <VStack extensions="w-full" gap="base">
          <HStack gap="sm">
            <Avatar
              size="sm"
              url={data.artist.avatarUrl}
              alt={data.artist.username}
            />
            <VStack>
              <Heading casing="uppercase" variant="secondary" color="primary">
                {data.title}
              </Heading>
              <LinkToItem
                variant="supplementary"
                path={`/${data.artist.username}`}
                text={`@${data.artist.username}`}
              />
            </VStack>
          </HStack>
          <VStack extensions="w-full">
            <HStack justify="between" extensions="w-full items-center">
              <HStack gap="sm" extensions="items-center">
                <Container extensions="bg-white/[15%] p-1 rounded-full">
                  <Icon icon="location" />
                </Container>
                <VStack>
                  <Text variant="label" color="primary">
                    {data.arena}
                  </Text>
                  <Text variant="supplementary">{data.location}</Text>
                </VStack>
              </HStack>
              <Container extensions="mobile:hidden tablet-sm:block">
                <Button onClick={() => onClick(data)} size="sm">
                  Learn More
                </Button>
              </Container>
            </HStack>
          </VStack>
        </VStack>
      </Card.Footer>
    </Card>
  );
}
